import { useEffect, useRef, useState } from "react";

const SignupBanner = () => {
  const videoRef = useRef(null);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) {
      return () => {};
    }

    const handleLoadedData = () => {
      setIsVideoLoaded(true);
    };

    const handleError = () => {
      setHasError(true);
    };

    video.addEventListener("loadeddata", handleLoadedData);
    video.addEventListener("error", handleError);

    return () => {
      if (!video) {
        return;
      }

      video.removeEventListener("loadeddata", handleLoadedData);
      video.removeEventListener("error", handleError);
    };
  }, []);

  const videoSrc = `${process.env.GATSBY_STATIC_ASSET_URL}/padua-landing-video.mp4`;

  return (
    <div className="signup-banner">
      <video
        ref={videoRef}
        autoPlay
        loop
        muted
        playsInline
        style={{
          display: "block",
          width: "100%",
          height: "100vh",
          objectFit: "cover",
          opacity: isVideoLoaded ? 1 : 0,
          transition: "opacity 0.3s ease-in-out",
        }}
      >
        <source src={videoSrc} type="video/mp4" />
        {hasError && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              color: "white",
              textAlign: "center",
            }}
          >
            Video could not be loaded
          </div>
        )}
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default SignupBanner;
